<template>
  <div class="index">
<!--    <swiper :options="swiperOption" class="swiper">-->
<!--      &lt;!&ndash; slides &ndash;&gt;-->
<!--      <swiper-slide class="slide" @click="newDetails(item.news_id,item.skip)" v-for="(item, index) in info.banner"-->
<!--                    :key="index">-->
<!--        <img :src="item.src" width="1202" height="450" class="img" alt="index">-->
<!--      </swiper-slide>-->
<!--      &lt;!&ndash; Optional controls &ndash;&gt;-->
<!--      <div class="swiper-pagination" slot="pagination"></div>-->
<!--    </swiper>-->

    <div class="swiper-container swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide slide" @click="newDetails(item.news_id,item.skip)" v-for="(item, index) in info.banner"
             :key="index"><img :src="item.src" width="1202" height="450" class="img" alt="index">
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <div class="indexTit">
      <router-link tag="span" to="/learning">我 / 的 / 课 / 程 / 任 / 务</router-link>
    </div>
    <div class="indexCourse">
      <ul class="publick">
        <li v-for="(item, index) in info.course_task" :key="index">
          <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
            <div class="img">
              <img :src="item.cover" width="287" height="175" alt="">
              <div v-if="item.tag" class="hot">{{item.tag}}</div>
              <!--              <div class="label">-->
              <!--                <span v-for="(items, indexs) in item.level" :key="indexs">{{items.name}}</span>-->
              <!--              </div>-->
            </div>
            <div class="describe line-clamp-2">{{item.title}}</div>
            <div class="dykc">{{item.ffjz_course}}</div>
            <div class="num">
              <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
              <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="indexTit">
      <router-link tag="span" to="/CourseList">公 /开 / 课</router-link>
    </div>
    <div class="indTask">
      <div class="publick">
        <div class="top">
          <li v-for="(item, index) in info.ad" :key="index">
            <router-link :to="{ path: '/CourseDetails', query: { id: item.px_course_id }  }">
              <img :src="item.cover" width="100%" height="100%" alt="">
            </router-link>
          </li>
        </div>
        <div class="bot">
          <li v-for="(item, index) in info.course_open" :key="index">
            <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
              <div class="img">
                <img :src="item.cover" width="287" height="175" alt="">
                <div v-if="item.tag" class="hot">{{item.tag}}</div>
                <!--                <div class="label">-->
                <!--                  <span v-for="(items, indexs) in item.course_task" :key="indexs">{{items.name}}</span>-->
                <!--                </div>-->
              </div>
              <div class="describe line-clamp-2">{{item.title}}</div>
              <div class="dykc">{{item.ffjz_course}}</div>
              <div class="dykc">{{item.period_title}}</div>
              <div class="num">
                <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
                <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
                <div class="price fr">￥{{item.price}}</div>
              </div>
            </router-link>
          </li>
        </div>
      </div>
    </div>
    <div class="indexTit">
      <router-link tag="span" to="/live">直 / 播</router-link>
    </div>
    <div class="indexCourse">
      <ul class="publick">
        <li v-for="(item, index) in info.live" :key="index">
          <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
            <div class="img">
              <img :src="item.cover" width="287" height="175" alt="">
              <div v-if="item.tag" class="hot">{{item.tag}}</div>
              <!--              <div class="label">-->
              <!--                <span v-for="(items, indexs) in item.course_task" :key="indexs">{{items.name}}</span>-->
              <!--              </div>-->
            </div>
            <div class="describe line-clamp-2">{{item.title}}</div>
            <div class="dykc">{{item.ffjz_course}}</div>
            <div class="num">
              <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
              <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
              <div class="price fr">￥{{item.price}}</div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="indexTit">
      <router-link tag="span" to="/newsList">新 / 闻 / 资 / 讯</router-link>
    </div>
    <div class="indNews">
      <ul class="publick">
        <li class="li" v-for="(item, index) in info.news" :key="index">
          <div v-if="item.tag" class="hot">热门资讯</div>
          <div class="content hotContent">
            <div class="h5">
              <router-link :to="{ path: '/newsDetails', query: { id: item.id }  }" tag="span">
                {{item.title}}
              </router-link>
            </div>
            <div class="p">{{item.describe}}</div>
          </div>
          <div class="bot">
            <span class="fl">浏览：{{item.read_num}}</span>
            <span class="fr">
                <router-link :to="{ path: '/newsDetails', query: { id: item.id }  }" tag="span">阅读全文</router-link>
              </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="indexTit">
      <router-link tag="span" to="/newsList">排 / 行 / 榜</router-link>
    </div>
    <div class="indNews">
      <div class="box">
        <div class="leaderboard">
          <div class="myTit">我的年榜当前排名:</div>
          <div class="myLi">
            <div class="num fl">
              <span>{{years.my.rank}}</span>
            </div>
            <div class="img fl"><img :src="years.my.avatar" width="70" height="70" alt=""></div>
            <div class="txt fl">
              <p>{{years.my.username}}</p>
              <!--            <p>{{years.my}}</p>-->
            </div>
            <div class="points fr">{{years.my.points}}分</div>
          </div>

          <div class="ul">
            <li v-for="(item,index) in years.list" :key="index">
              <div class="num fl">
                <img v-if="index === 0" src="./1.png" width="35" height="30" alt="">
                <img v-if="index === 1" src="./2.png" width="35" height="30" alt="">
                <img v-if="index === 2" src="./3.png" width="35" height="30" alt="">
                <span v-if="index !== 0 && index !== 1 && index !== 2">{{index+1}}</span>
              </div>
              <div class="img fl"><img :src="item.avatar" width="70" height="70" alt=""></div>
              <div class="txt fl">
                <p>{{item.username}}</p>
                <p>{{item.name}}</p>
              </div>
              <div class="points fr">{{item.points}}分</div>
            </li>
          </div>
        </div>
        <div class="leaderboard">
          <div class="myTit">我的月榜当前排名:</div>
          <div class="myLi">
            <div class="num fl">
              <span>{{months.my.rank}}</span>
            </div>
            <div class="img fl"><img :src="months.my.avatar" width="70" height="70" alt=""></div>
            <div class="txt fl">
              <p>{{months.my.username}}</p>
              <!--            <p>{{years.my}}</p>-->
            </div>
            <div class="points fr">{{months.my.points}}分</div>
          </div>

          <div class="ul">
            <li v-for="(item,index) in months.list" :key="index">
              <div class="num fl">
                <img v-if="index === 0" src="./1.png" width="35" height="30" alt="">
                <img v-if="index === 1" src="./2.png" width="35" height="30" alt="">
                <img v-if="index === 2" src="./3.png" width="35" height="30" alt="">
                <span v-if="index !== 0 && index !== 1 && index !== 2">{{index+1}}</span>
              </div>
              <div class="img fl"><img :src="item.avatar" width="70" height="70" alt=""></div>
              <div class="txt fl">
                <p>{{item.username}}</p>
                <p>{{item.name}}</p>
              </div>
              <div class="points fr">{{item.points}}分</div>
            </li>
          </div>
        </div>
        <div class="leaderboard">
          <div class="myTit">我的周榜当前排名:</div>
          <div class="myLi">
            <div class="num fl">
              <span>{{weeks.my.rank}}</span>
            </div>
            <div class="img fl"><img :src="weeks.my.avatar" width="70" height="70" alt=""></div>
            <div class="txt fl">
              <p>{{weeks.my.username}}</p>
              <!--            <p>{{years.my}}</p>-->
            </div>
            <div class="points fr">{{weeks.my.points}}分</div>
          </div>

          <div class="ul">
            <li v-for="(item,index) in weeks.list" :key="index">
              <div class="num fl">
                <img v-if="index === 0" src="./1.png" width="35" height="30" alt="">
                <img v-if="index === 1" src="./2.png" width="35" height="30" alt="">
                <img v-if="index === 2" src="./3.png" width="35" height="30" alt="">
                <span v-if="index !== 0 && index !== 1 && index !== 2">{{index+1}}</span>
              </div>
              <div class="img fl"><img :src="item.avatar" width="70" height="70" alt=""></div>
              <div class="txt fl">
                <p>{{item.username}}</p>
                <p>{{item.name}}</p>
              </div>
              <div class="points fr">{{item.points}}分</div>
            </li>
          </div>
        </div>
      </div>
    </div>
    <div class="indTeacher">
      <div class="tit">
        <span>早 / 极 / 客 / 讲 / 师 / 团 / 队</span>
        <router-link tag="span" class="fr" to="/teacherList">
          查看更多>
        </router-link>
      </div>
      <ul class="publick">
        <li v-for="(item, index) in info.lecturer" :key="index">
          <router-link :to="{ path: '/teacherDetails', query: { id: item.id }  }">
            <div class="img"><img :src="item.avatar" width="80" height="80" alt=""></div>
            <div class="name">{{item.name}}</div>
            <div class="det">{{item.signature}}</div>
            <div class="con">{{item.profile}}</div>
          </router-link>
        </li>
      </ul>
    </div>
    <layerRight></layerRight>
    <div v-if="advertisingFalse" @click="advertisingClick($event)" class="advertising">
      <img @click="newDetails(ad_news.news_id,ad_news.skip)" :src="ad_news.cover" alt="">
    </div>
  </div>
</template>

<script>
  import layerRight from '@/components/layerRight/layerRight'
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'

  let vm = null
  export default {
    components: {
      layerRight
    },
    data () {
      return {
        // swiperOption: {
        //   autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: false
        //   },
        //   loop: true,
        //   pagination: {
        //     el: '.swiper-pagination'
        //   },
        //   on: {
        //     click: function () {
        //       console.log(this.realIndex)
        //       let index = this.realIndex
        //       vm.newDetails(vm.info.banner[index].news_id, vm.info.banner[index].is_skip)
        //     }
        //   }
        // },
        info: [],
        ad_news: {},
        advertisingFalse: false,
        months: {},
        weeks: {},
        years: {}
      }
    },
    created () {
      this.$store.state.headindex = 0
      this.getData()
      vm = this
      // setTimeout(res => {
      //   this.advertisingFalse = false
      // }, 2000)
    },
    methods: {
      getData () {
        this.$http.post('/apipx/Index/info', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
            this.ad_news = res.data.ad_news
            this.months = res.data.points.month
            this.weeks = res.data.points.week
            this.years = res.data.points.year
            if (this.ad_news) {
              this.advertisingFalse = true
            }

            var that = this
            that.$nextTick(function () {
              var mySwiper = new Swiper('.swiper-container', {
                direction: 'horizontal',
                loop: true,
                pagination: {
                  el: '.swiper-pagination'
                },
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false
                },
              })
            })
          }
        })
      },
      advertisingClick (e) {
        if (e.target.className === 'advertising') {
          this.advertisingFalse = false
        }
      },
      newDetails (id, skip) {
        if (skip === 1) {
          this.$router.push({
            path: '/newsDetails',
            query: {
              id: id
            }
          })
        }
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .index {
    .swiper {
      width: 1200px;
      height: 450px;
      margin: 40px auto;
      border-radius: 30px;
      overflow: hidden;
      box-shadow: 0px 0px 40px #c3ddfd;
      background: transparent;

      .swiper-pagination-bullet-active {
        opacity: 1;
        background: #fff;
      }

      .swiper-pagination-bullet {
        background: #fff;
        width: 10px;
        height: 10px;
      }

      .slide {
        width: 100%;
        height: 100%;
      }
    }

    .indexTit {
      width: 100%;
      height: 80px;
      line-height: 80px;
      font-size: 30px;
      color: #5c5c5c;
      text-align: center;

      span {
        background: url("titBg.png") no-repeat right top;
        padding: 20px 28px;
        cursor: pointer;
      }

    }

    .indexCourse {
      width: 100%;
      overflow: hidden;
      box-shadow: 0px 20px 20px -20px #f5f5f5;
      padding-bottom: 80px;
      margin-bottom: 50px;

      li {
        width: 287px;
        overflow: hidden;
        float: left;
        height: 289px;
        margin: 50px 17.3px 0 0;
        cursor: pointer;

        .dykc {
          margin: 10px auto;
          color: #8f8f8f;
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        .img {
          width: 287px;
          height: 175px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          .hot {
            position: absolute;
            width: 50px;
            height: 35px;
            border-radius: 0 17.5px 17.5px 0;
            background-color: #fff;
            text-align: center;
            line-height: 35px;
            color: #fc8375;
            font-size: 14px;
            font-weight: bold;
            left: 0;
            top: 20px;
          }

          .label {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 20px;

            span {
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff;
              padding: 5px 8px;
              border-radius: 10px;
              margin: 0 0 0 10px;
              line-height: 35px;
            }
          }
        }

        .describe {
          width: 287px;
          height: 20px;
          line-height: 20px;
          margin-top: 15px;
        }

        .num {
          height: 20px;
          width: 100%;
          font-size: 12px;
          color: #8f8f8f;
          margin-top: 10px;

          img {
            display: block;
            float: left;
          }

          .people {
            line-height: 20px;
            margin-right: 20px;

            img {
              margin: 3px 5px 0 0;
            }
          }

          .comment {
            line-height: 20px;

            img {
              margin: 5px 5px 0 0;
            }
          }

          .price {
            color: #ff8484;
            font-size: 14px;
          }
        }
      }
    }

    .indTask {
      width: 100%;
      overflow: hidden;
      box-shadow: 0px 20px 20px -20px #f5f5f5;
      padding-bottom: 80px;
      margin-bottom: 50px;

      .top {
        margin: 50px auto 0;
        height: 125px;

        li {
          width: 590px;
          height: 125px;
          border-radius: 10px;
          overflow: hidden;
          float: left;
          margin: 0 20px 0 0;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .bot {
        li {
          width: 287px;
          overflow: hidden;
          float: left;
          margin: 50px 17.3px 0 0;
          cursor: pointer;

          .dykc {
            margin: 10px auto;
            color: #8f8f8f;
          }

          &:nth-child(4n) {
            margin-right: 0;
          }

          .img {
            width: 287px;
            height: 175px;
            border-radius: 5px;
            overflow: hidden;
            position: relative;

            .hot {
              position: absolute;
              width: 50px;
              height: 35px;
              border-radius: 0 17.5px 17.5px 0;
              background-color: #fff;
              text-align: center;
              line-height: 35px;
              color: #fc8375;
              font-size: 14px;
              font-weight: bold;
              left: 0;
              top: 20px;
            }

            .label {
              width: 100%;
              position: absolute;
              left: 0;
              bottom: 20px;

              span {
                background-color: rgba(0, 0, 0, 0.5);
                color: #fff;
                padding: 5px 8px;
                border-radius: 10px;
                margin: 0 0 0 10px;
                line-height: 35px;
              }
            }
          }

          .describe {
            width: 287px;
            height: 20px;
            margin-top: 15px;
            line-height: 20px;
          }

          .details {
            font-size: 12px;
            color: #8f8f8f;
            margin-top: 10px;
          }

          .num {
            height: 20px;
            width: 100%;
            font-size: 12px;
            color: #8f8f8f;
            margin-top: 10px;

            img {
              display: block;
              float: left;
            }

            .people {
              line-height: 20px;
              margin-right: 20px;

              img {
                margin: 3px 5px 0 0;
              }
            }

            .comment {
              line-height: 20px;

              img {
                margin: 5px 5px 0 0;
              }
            }

            .price {
              color: #ff8484;
              font-size: 14px;
            }
          }
        }
      }
    }

    .indNews {
      width: 100%;
      overflow: hidden;
      // box-shadow: 0px 20px 20px -20px #f5f5f5;
      padding-bottom: 80px;
      margin-bottom: 50px;

      .li {
        width: 326px;
        height: 412px;
        padding: 30px;
        box-shadow: 0px 0px 40px #f5f5f5;
        float: left;
        margin: 50px 21px 0 0;
        border-radius: 20px;
        position: relative;

        &:nth-child(3n) {
          margin-right: 0;
        }

        .hot {
          width: 90px;
          height: 30px;
          background-color: #ff8484;
          color: #fff;
          font-size: 14px;
          position: absolute;
          left: 0;
          top: 35px;
          border-radius: 0 15px 15px 0;
          line-height: 30px;
          text-align: center;
        }

        .content {
          height: 350px;
          overflow: hidden;
          margin-top: 14px;

          .h5 {
            font-size: 18px;
            line-height: 30px;
            height: 60px;
            overflow: hidden;
            width: 326px;
            cursor: pointer;

            &:hover {
              text-decoration: underline;
            }
          }

          .p {
            margin-top: 10px;
            line-height: 25px;
            width: 326px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 11;
            overflow: hidden;
            height: 275px;
          }
        }

        .hotContent {
          height: 300px;
          margin-top: 65px;

          .p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 9;
            overflow: hidden;
            height: 225px;
          }
        }

        .bot {
          font-size: 12px;
          color: #757575;
          margin-top: 20px;

          .fr {
            color: #ff8484;
            cursor: pointer;
          }
        }
      }

      .box{
        width: 1200px;
        margin: 20px auto 0;

        .leaderboard {

          width: 380px;
          float: left;
          margin-left: 30px;

          &:first-child{
            margin: 0;
          }

          .myTit {
            color: #8b8b8b;
            font-size: 16px;
          }

          .myLi {
            height: 70px;
            padding: 15px;
            box-shadow: 0px 0px 20px #e2e0e0;
            border-radius: 35px;
            margin: 20px auto;

            .num {
              width: 50px;
              height: 70px;
              line-height: 70px;
              font-style: italic;
              color: #969696;
              position: relative;

              span {
                text-indent: 10px;
              }

              img {
                position: absolute;
                left: 5px;
                top: 50%;
                margin: -15px 0 0 0;
              }
            }

            .img {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              overflow: hidden;
            }

            .txt {
              width: 100px;
              height: 70px;
              margin: 0 0 0 20px;

              p:first-child {
                font-size: 16px;
                margin: 15px 0 0 0;
              }

              p:last-child {
                color: #a4a4a4;
                margin: 5px 0 0 0;
              }
            }

            .points {
              font-size: 20px;
              color: #ff827b;
              line-height: 70px;
            }
          }

          .ul {
            margin: 20px auto;
            box-shadow: 0px 0px 20px #e2e0e0;
            border-radius: 35px;
            overflow: hidden;
            padding: 15px;

            li {
              height: 70px;
              padding: 15px 0;
              border-bottom: 1px solid #ebebeb;

              .num {
                width: 50px;
                height: 70px;
                line-height: 70px;
                font-style: italic;
                color: #969696;
                position: relative;

                span {
                  padding-left: 10px;
                }

                img {
                  position: absolute;
                  left: 5px;
                  top: 50%;
                  margin: -15px 0 0 0;
                }
              }

              .img {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                overflow: hidden;
              }

              .txt {
                width: 100px;
                height: 70px;
                margin: 0 0 0 20px;

                p:first-child {
                  font-size: 16px;
                  margin: 15px 0 0 0;
                }

                p:last-child {
                  color: #a4a4a4;
                  margin: 5px 0 0 0;
                }
              }

              .points {
                font-size: 20px;
                color: #ff827b;
                line-height: 70px;
              }
            }
          }
        }
      }


    }

    .indTeacher {
      width: 100%;
      height: 654px;
      background: url("indtea.png") no-repeat center center;
      overflow: hidden;

      .tit {
        width: 1200px;
        margin: 60px auto 0;
        height: 80px;
        line-height: 80px;
        font-size: 30px;
        text-align: center;
        color: #fff;

        .fr {
          font-size: 16px;
          cursor: pointer;
        }
      }

      li {
        width: 288px;
        height: 358px;
        background-color: #fff;
        border-radius: 20px;
        float: left;
        margin: 80px 16px 0 0;

        &:last-child {
          margin-right: 0;
        }

        .img {
          margin: -40px auto 0;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
        }

        .name {
          font-size: 16px;
          text-align: center;
          margin: 15px auto 0;
        }

        .det {
          text-align: center;
          margin: 10px auto 0;
          color: #6f6f6f;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          max-height: 90px;
          overflow: hidden;
          padding: 0 15px;
          line-height: 30px;
        }

        .con {
          line-height: 30px;
          height: 180px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          padding: 0 15px;
          margin: 15px auto 0;
        }
      }
    }

    .advertising {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 99;
      background-color: rgba(0, 0, 0, 0.3);
      text-align: center;

      img {
        position: fixed;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 999;
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue